import { actionCreatorFactory } from 'typescript-fsa';
import { INode } from '@cbridge-packages/node';

export namespace SymbolPoolAction {
  const actionCreator = actionCreatorFactory('SymbolPool');

  export const select = actionCreator<{ nodeId: INode['nodeId'] }>('SELECT');
  export const toggleSelect = actionCreator<{ nodeId: INode['nodeId'] }>('TOGGLE_SELECT');
  export const clearSelect = actionCreator<void>('CLEAR_SELECT');
}
